<template>
  <v-card :key="updates">
    <v-card-title>
      <v-flex v-for="(x, key) in schema.filters" :key="key">
        <v-text-field
          v-if="x.type === 'text'"
          append-icon="search"
          :label="x.label"
          @input="filterSearch($event, x.parameter)"
        ></v-text-field>
        <v-select
          v-if="x.type === 'select'"
          :items="x.items"
          :label="x.label"
          @change="filterSearch($event, x.parameter)"
        ></v-select>
      </v-flex>
    </v-card-title>
    <v-data-table
      :headers="schema.headers"
      :items="schema.rows"
      item-key="name"
      :entity-ref="schema.entityRef"
      :pagination.sync="pagination"
      :search="filters"
      :custom-filter="customFilter"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th v-if="schema.selectable == true">
            <!-- <v-checkbox
                            :input-value=" props.all"
                            :indeterminate="props.indeterminate"
                            primary
                            hide-details
                            @click.stop="toggleAll"
            ></v-checkbox>-->
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : ''
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <!-- <tr :active="props.item.selected" @click="props.item.selected= !props.item.selected" @dblclick="setResult(props.item)">
                        <td><v-checkbox
                            v-model="props.item.selected"
        ></v-checkbox></td>-->
        <tr @click="rowClick(props)">
          <td v-if="schema.selectable == true">
            <v-checkbox
              :value="selectedIndex == props.index"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td
            v-for="(header, index) in schema.headers"
            :key="index"
            :class="header.textClass"
          >
            {{ props.item[header.value] }}
          </td>
          <!-- xs-md-xl , left-center-right  -->
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CustomTableWidget',
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filters: this.schema.filtersValues,
      pagination: this.schema.pagination || {},
      selectedIndex: -1,
      updates: 0
    }
  },
  mounted() {
    var self = this
    var listId

    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }
    axios
      .get(
        `http://195.189.195.105:8081/cezy-api/webapi/entities/${this.schema.entityRef}`,
        config
      )
      .then(function(res) {
        // console.log("RESPONSE: " + JSON.stringify(res.data))

        listId = res.data.forms.list

        axios
          .get(
            `http://195.189.195.105:8081/cezy-api/webapi/forms/${listId}`,
            config
          )
          .then(function(res) {
            var tabHeaders
            for (let custom in res.data.schema) {
              if (res.data.schema[custom].type === 'custom-table') {
                tabHeaders = res.data.schema[custom].headers
              }
            }

            self.schema.headers = tabHeaders
          })
          .catch(function(error) {
            console.log('Error', error)
          })
      })
      .catch(function(error) {
        console.log('Error', error)
      })

    axios
      .get(
        `http://195.189.195.105:8081/cezy-api/webapi/entities/${this.schema.entityRef}/data`,
        config
      )
      .then(function(res) {
        //  console.log("Date!!!! " + JSON.stringify(res.data));
        self.schema.rows = res.data
        self.updates++
      })
      .catch(function(error) {
        console.log('Error', error)
      })
  },
  methods: {
    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers)
      this.schema.filters.forEach(function(x) {
        cf.registerFilter(x.parameter, function(searchWord, items) {
          if (searchWord.trim() === '') return items
          return items.filter(function(item) {
            if (item[x.parameter] == undefined) return
            return item[x.parameter]
              .toLowerCase()
              .includes(searchWord.toLowerCase())
          }, searchWord)
        })
      })
      // cf.registerFilter('search', function (searchWord, items) {
      //   if (searchWord.trim() === '') return items;
      //   return items.filter(item => {
      //     return item.name.toLowerCase().includes(searchWord.toLowerCase());
      //   }, searchWord);
      // });
      // cf.registerFilter('added_by', function (added_by, items) {
      //   if (added_by.trim() === '') return items;
      //   return items.filter(item => {
      //     return item.added_by.toLowerCase() === added_by.toLowerCase();
      //   }, added_by);
      // });
      // Its time to run all created filters.
      // Will be executed in the order thay were defined.
      return cf.runFilters()
    },
    /**
     * Handler when user input something at the "Filter" text field.
     */
    filterSearch(val, parameter) {
      var obj = {}
      obj[parameter] = val
      this.filters = this.$MultiFilters.updateFilters(this.filters, obj)
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    change(item) {
      item.selected = !item.selected
    },
    rowClick(value) {
      let ref = {
        entry_id: value.item._id,
        entity_id: this.schema.entityRef
      }
      value.item.ref = ref
      this.selectedIndex = value.index
      this.$emit('indexChange', value.item)
      // console.log('CustomTbaleWidget    ' + JSON.stringify(value.item))
    }
  }
}
</script>
